import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
// import { generateExcelASITable1 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import { agriPriceElectricityReport } from "../ExportPriceWagesExcel";
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';



const PriceElectricityReport = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [tableReportData, setTableReportData] = useState([]);
    const [buttonAccess, setButtonAccess] = useState({
      userLevel: "",
      roles: "",
      isVisible: false,
    });
  
    // const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    // const decode_token = jwtDecode(token);
    
    const navigate = useNavigate();
    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // };
    const config = getAuthHeaders();
  
  
    const storedLanguage = localStorage.getItem('language');
  
    const getAllYears = () => {
        const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = currentYear; year >= 2010; year--) {
          yearsArray.push(year);
        }
        return yearsArray;
      };
  
  
    useEffect(() => {
      const level = handleUserLevelAccessPermissions(decode_token);
      setButtonAccess(level);
      setYears(getAllYears());
    }, []);
  
    const handleDropdownChange = (e) => {
      setYearName(e.target.value);
    };
  
    const handleGenerateExcel = () => {
      if (!yearName) {
        toast.error("Please select a Survey Year", messages.COLOR_RED);
        return;
      }
  
      showLoading(true);
      // Prepare payload
      const payload = {
        year: yearName,
      };
  
      // POST request to API
      axios
          .post(`${API_URL}api/price/PriceElectricityReport`, payload, config)
          .then((response) => {
              // Handle success and generate the Excel file directly
              const priceElectricityReport = response.data.data.groupCodes;
  
              if (!priceElectricityReport || priceElectricityReport.length === 0) {
                toast.info("Data not found");
                showLoading(false);
                return;
              }
  
              let excelFileName = `electricityReport_${yearName}`;
              const excelObjectData = {
                fileName: excelFileName,
                reportType: excelFileName,
                fileType: 'xls',
                sheetName: "priceelectricityreport",
                firstRowMergeCells: "A1:G1",
                firstRowExportData: ' PRICE ELECTRICITY REPORT',
                firstRowCellNumber: 7,
                headerEnglishColumns: [
                  'ITEM TITLE TYPE NAME', 'REAL MONTH', 'REAL YEAR', 'REVISED YEAR', 'ITEM TITLE NAME', 'REAL YEAR PRICE', 'REVISED YEAR PRICE'
                ],
              };
  
              const transformedData = priceElectricityReport.map(item => [
                item.itemTitleTypeName,
                item.REAL_MONTH,
                item.REAL_YEAR,
                item.revisedYear,
                item.itemTitleName,
                item.form6 === "" ? '0.00' :item.form6,
                item.form7 === "" ? '0.00' : item.form7,
               
              ]);
  
              excelObjectData.excelRowData = transformedData;
  
              agriPriceElectricityReport(excelObjectData);
  
              showLoading(false);
          })
          .catch((error) => {
              // Handle error if needed
              console.error('API Error:', error);
              showLoading(false);
          });
  };
  
    return (
      <>
        <GlobalLoading />
        <ToastContainer />
        <div className="container-fluid py-3">
          <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
              <div className="row align-items-center">
              <h4 className="page_heading">
                {/* <h3 style={{ color: '#F47720' }}>Price Wages Indices System <span style={{ color: 'black' }}>Price Electricity Report</span></h3> */}
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.PRICE_ELECTRICITY_REPORT : priceTitle.en.PRICE_ELECTRICITY_REPORT }} />
              </h4>
               <div className="row align-items-center">
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="fw-bold h6">
                    Select Base Year
                      </label>
                    <select
                      name="year_name"
                      className="form-select"
                      onChange={handleDropdownChange}
                      value={yearName}
                    >
                      <option value="" disabled>
                        Select Year
                      </option>
                      {years &&
                        years.map((ele, index) => (
                          <option key={index} value={ele}>
                            {(ele)}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-xl-2 col-lg-12 mb-3">
                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </>
    )
  }

export default PriceElectricityReport